import { Product } from '@/src/types/api-types'
import { ProductsBasket } from '@/type/basket'

const isProductAvailable = (product: Product | ProductsBasket): boolean => {
  return (
    (parseFloat(product.amount) > 0 && parseFloat(product.amount) >= product.coeffQuantity) ||
    product.infiniteStock
  )
}

export default isProductAvailable
